var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.question.showPreviewContainer
    ? _c(
        "div",
        { class: _vm.question.cssClasses.fileList || undefined },
        [
          _vm._l(_vm.question.renderedPages, function (page) {
            return _vm.question.supportFileNavigator
              ? _c("sv-file-page", {
                  key: page.id,
                  attrs: { page: page, question: _vm.question },
                })
              : _vm._e()
          }),
          _vm._v(" "),
          _vm._l(_vm.question.previewValue, function (item, index) {
            return !_vm.question.supportFileNavigator
              ? _c("sv-file-item", {
                  key: index,
                  attrs: { item: item, question: _vm.question },
                })
              : _vm._e()
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }